module.exports = __webpack_public_path__ + "static/media/pennylane.f4dca566.png";